module.exports = __webpack_public_path__ + "static/about03-0099b93c5032706573bfe6bfe6a9fe84.svg";